import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';
import { queryClient } from 'providers';

import { DashboardQueryKeys } from './query-keys';
const { createDashBoard } = DashBoardApiService();

export const useCreateDashBoard = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: FormData) => {
      return createDashBoard(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: DashboardQueryKeys.all,
        });
        message.success('Documents Upload successfully');
      },
    },
  );
};
